<template>
  <Loading v-if="loadingScreen" :text="'Atualizando'"></Loading>
  <div id="SessoesComponent" class="text-left menu-component" v-else>
    <h4 class="dashboard-component">Páginas</h4>
    <div class="row" v-if="categories.length == 0">
      <div class="col-12 text-center">
        <h5>{{ msgLoading }}</h5>
      </div>
    </div>
    <div class="row m-0" v-else>
      <div class="col-12 p-0">
        <div
          class="item"
          v-for="(element, index) in filterHome"
          :key="element.id"
        >
          <div class="row align-items-center">
            <div class="col-auto">
              <i class="fal fa-lock fal fa-lock pr-3 pl-2 opacity-25"></i>
            </div>
            <div class="col pl-0">
              <div class="text text-left">
                <span
                  class="section-name"
                  @click="handleClickCategory(
                    element.listPages,
                    element.id,
                    element.type,
                    element.route
                  )"
                  >{{ normalizeName(element.name) }}</span
                >
              </div>
            </div>
            <div class="col-auto">
              <div class="removeIcon text-right">
                <button class="btn btn-white p-2">
                  <i
                    class="fal fa-cog text-dark opacity-50"
                    @click="editSection(element, index)"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <draggable
          :force-fallback="true"
          v-model="categories"
          group="pages"
          :options="{
            draggable: '.item-draggable',
            handle: '.fa-bars',
          }"
          @end="saveCategories(false)"
        >
          <div
            v-for="(element, index) in categories"
            :key="element.id"
            class="item item-draggable"
            :class="[element.isHome ? 'd-none' : '']"
          >
            <div class="row align-items-center py-3">
              <div class="col-auto">
                <div class="moveIcon text-center">
                  <i class="fas fa-bars"></i>
                </div>
              </div>
              <div class="col pl-0">
                <div class="text text-left">
                  <span
                    class="section-name"
                    @click="handleClickCategory(
                      element.listPages,
                      element.id,
                      element.type,
                      element.route
                    )"
                    >{{ normalizeName(element.name) }}</span
                  >
                </div>
              </div>
              <div class="col-auto">
                <div class="removeIcon text-right">
                  <a
                    :href="getLink(siteUrl, element.route)"
                    target="_blank"
                    class="btn btn-white p-2"
                  >
                    <i class="fal fa-link text-dark opacity-50"></i>
                  </a>
                  <button class="btn btn-white p-2">
                    <i
                      class="fal fa-cog text-dark opacity-50"
                      @click="editSection(element, index)"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <div
      v-if="categories.length > 0"
      class="add-section item text-center py-3"
      @click="addSessionModal = !addSessionModal"
    >
      <button class="btn btn-white p-2">
        <i class="fal fa-plus pr-3"></i>
        <span class="text-primary font-weight-bold font-title">Criar página</span>
      </button>
    </div>
    <div class="row m-0 mt-3">
      <div class="col text-right px-0 py-2">
        <span class="advanced-config" v-b-toggle.advanced-config>
          <i class="fas fa-cog"></i>
        </span>
      </div>
      <b-collapse
        id="advanced-config"
        accordion="advanced-config"
        role="tabpanel"
      >
        <div class="row m-0">
          <div class="col-12">
            <p>
              <strong>Scripts do site</strong>
            </p>
          </div>
          <div class="col-12 pt-2">
            <p class="mb-1">Código dentro da tag &lt;head&gt;.</p>
            <textarea
              class="form-control form-control-bottom"
              v-model="siteHeaderScript"
              rows="2"
            ></textarea>
          </div>
          <div class="col-12 pt-2">
            <p class="mb-1">Código no final da tag &lt;body&gt;.</p>
            <textarea
              class="form-control form-control-bottom"
              v-model="siteFooterScript"
              rows="2"
            ></textarea>
          </div>
          <div class="col-12 pt-4">
            <p class="error-message" v-if="errorScript">
              {{ errorScript }}
            </p>
            <button
              class="btn btn-primario btn-block"
              v-if="!updatingScripts"
              @click="applySiteScripts"
            >
              Aplicar scripts
            </button>
            <button class="btn btn-primario btn-block disabled" v-else>
              <i class="fas fa-spinner fa-spin"></i> Atualizando
            </button>
          </div>
        </div>
      </b-collapse>
    </div>

    <NewSection
      @newSessionLoading="loadingScreen = $event"
      v-if="addSessionModal"
      :sectionsCategories="categories"
      @returnAddSessionModal="addSessionModal = $event"
      @newCategories="categories = $event"
      :showAllOptions="true"
    />

    <b-modal
      id="editSectionModal"
      v-model="editSectionModal"
      title="Editar Página"
      centered
      modal-class="bg-white"
      content-class="no-border"
      dialog-class="modal-lg"
      hide-footer
      @ok="handleUpdate()"
      @close="resetEditModal()"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="row align-items-center">
        <div class="col-12 form-group">
          <label class="font-14 mb-0" for="sessionName">Nome:</label>
          <input
            class="form-control form-control-bottom"
            type="text"
            name="sessionName"
            id="SessionName"
            v-model="editableElement.name"
          />
          <p class="error-message" v-if="errorMessage">
            {{ errorMessage }}
          </p>
        </div>

        <div class="col-12 mt-2 mb-4">
          <div class="row text-left align-items-center border-bottom-gray m-0">
            <div class="col-4 font-14">
              <CheckBox
                v-if="editableElement.type != 'external_url'"
                label="Exibir na página inicial"
                :visible="editableElement.visible"
                @onCheck="editableElement.visible = $event"
              />
            </div>
            <div class="col-4 font-14">
              <CheckBox
                label="Exibir no menu"
                :visible="editableElement.menu_visible"
                @onCheck="editableElement.menu_visible = $event"
              />
            </div>
            <div class="col-4 font-14">
              <CheckBox
                label="Exibir botão flutuante"
                :visible="editableElement.show_opportunities_button"
                @onCheck="editableElement.show_opportunities_button = $event"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6" v-if="showSlides">
          <label class="font-14 mb-0">Capa da página</label>
          <ImageCarousel
            :editableElement="editableElement"
            :getActivePosts="getActivePosts"
            :activeImg="activeMainImage"
            :trashView="false"
            @changeImage="activeMainImage = $event"
          />
        </div>
        <div class="col-12 col-md-6" v-if="showSlides">
          <label class="font-14 mb-0">Prévia Whats (og:image)</label>
          <ImageCarousel
            :editableElement="editableElement"
            :getActivePosts="[...mainImagePost, ...getActivePosts]"
            :trashView="false"
            :activeImg="
              editableElement.ogImage
                ? editableElement.ogImage
                : activeMainImage
            "
            @changeImage="editableElement.ogImage = $event"
          />
        </div>

        <div class="col-12 mb-4" v-if="editableElement.isHome">
          <label class="font-14 mb-0" for="seoText"
            >Número máximo de posts exibidos na Home</label
          >
          <input
            id="pages"
            type="number"
            v-model="editableElement.pages"
            class="form-control"
          />
        </div>

        <div class="col-12 mb-4" v-if="editableElement.isHome">
          <label class="font-14 mb-0" for="seoText">Texto do H1</label>
          <input
            id="seoText"
            type="text"
            v-model="editableElement.seoText"
            class="form-control"
          />
        </div>

        <div class="col-12 mb-4" v-if="editableElement.type == 'external_url'">
          <label class="font-14 mb-0" for="sessionCodeHead"
            >Evento no Pixel do Facebook {{ editableElement.pixel }}</label
          >
          <select
            class="form-control"
            id="select-target-buttom"
            v-model="editableElement.pixel"
          >
            <option value="null">Sem ação</option>
            <option value="Contact">Contatos</option>
            <option value="Lead">Cadastros</option>
            <option value="SubmitApplication">Inscrições Enviadas</option>
            <option value="CompleteRegistration">Registros concluídos</option>
          </select>
        </div>
        <div class="col-12 mb-4" v-if="editableElement.id">
          <label class="font-14 mb-0" for="sessionCodeHead"
            >Crop da foto de capa</label
          >
          <select
            id="editableElementMainImageClass"
            class="form-control"
            v-model="editableElement.mainImage.class"
          >
            <option
              :value="option.value"
              v-for="(option, index) in classOptions"
              :key="index"
            >
              {{ option.text }}
            </option>
          </select>
        </div>

        <div class="col-12">
          <label class="font-14 mb-0" for="sessionCodeHead">
            Código dentro da tag &lt;head&gt;.
            <span class="advanced-danger">*Avançado</span>
          </label>
          <textarea
            v-model="editableElement.customHeader"
            name="sessionCodeHead"
            id="sessionCodeHead"
            rows="2"
            class="form-control form-control-bottom"
          ></textarea>
        </div>
        <div class="col-12 mt-3">
          <label class="font-14 mb-0" for="sessionCodeFooter">
            Código no final da tag &lt;body&gt;.
            <span class="advanced-danger">*Avançado</span>
          </label>
          <textarea
            v-model="editableElement.customFooter"
            name="sessionCodeFooter"
            id="sessionCodeFooter"
            rows="2"
            class="form-control form-control-bottom"
          ></textarea>
        </div>
      </div>
      <div class="row mt-5 justify-content-between">
        <div class="col-auto">
          <span v-if="!this.isHomePage" v-b-modal.confirm-remove-page>
            <button class="btn btn-white px-2" type="button">
              <i class="fal fa-trash-alt text-dark opacity-50"></i>
            </button>
          </span>
          <span
            v-if="!this.isHomePage && editableElement.listPages == 0"
            v-b-modal.confirm-clone-page
          >
            <button class="btn btn-white px-2" type="button">
              <i class="far fa-clone text-dark opacity-50"></i>
            </button>
          </span>
        </div>
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-primario px-5"
            @click.prevent="handleSave"
          >
            Salvar
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      centered
      id="confirm-clone-page"
      ref="confirm-clone-page"
      size="md"
      title="Clonar Página?"
      hide-footer
    >
      <div class="row justify-content-between align-items-center">
        <div class="col-12">
          <p>Você realmente deseja clonar esta página ?</p>
        </div>
        <div class="col-auto">
          <span
            @click="clonePage(editableElement.id)"
            class="d-flex align-items-center pointer section-message"
            >Clonar página
            <i v-if="loadingClone" class="fal fa-spinner fa-spin fa-2x ml-2"></i
          ></span>
        </div>
        <div class="col-auto text-right">
          <button
            class="btn btn-primario"
            @click="$bvModal.hide('confirm-clone-page')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      centered
      id="confirm-remove-page"
      ref="confirm-remove-page"
      size="md"
      title="Excluir Página?"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <p v-if="editableElement.listPages === 1">
            A página será excluída e as postagens serão movidas para a aba
            Novos, não será possível reverter essa ação.
          </p>

          <p v-else>
            Textos, links e imagens dessa página serão excluídos. Não será
            possível reverter essa ação.
          </p>

          <p v-if="editableElement.listPages !== 1 && editableElement.quantityRelatedPages > 1">
            <strong>Aviso:</strong> Essa página possui vínculo com outras páginas. Escolha de que forma
            deseja continuar com essa ação
          </p>
        </div>

        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <button
                        v-if="editableElement.listPages === 1 || editableElement.quantityRelatedPages === 1"
                        @click="deletePage(1);"
                        class="btn btn-primario btn-block my-3"
                    >
                        Excluir página
                    </button>

                    <button
                        v-if="editableElement.listPages !== 1 && editableElement.quantityRelatedPages > 1"
                        @click="deletePage(0);"
                        class="btn btn-primario btn-block my-3"
                    >
                        Excluir somente página
                    </button>

                    <button
                        v-if="editableElement.listPages !== 1 && editableElement.quantityRelatedPages > 1"
                        class="btn btn-secundario btn-block my-3"
                        @click="deletePage(1)"
                    >
                        Excluir página e vínculos
                    </button>

                    <button
                        class="btn btn-secundario btn-block my-3"
                        @click="$bvModal.hide('confirm-remove-page')"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CheckBox from "../components/atoms/checkBox.vue";
import NewSection from "./organisms/NewSection";
import ImageCarousel from "./molecules/ImageCarousel.vue";
import sectionsMixins from "@/mixins/sectionsMixins";
import MenuDraggable from "@/components/atoms/MenuDraggable.vue";
import Loading from '../components/Loading.vue';

import axios from "axios";
import draggable from "vuedraggable";

import { mapGetters } from "vuex";

export default {
  name: "SessoesComponent",
  data() {
    return {
      loadingScreen: false,
      siteUrl: null,
      siteId: null,
      uploadedPictures: [],
      activeMainImage: "",
      showSlides: false,
      addSessionModal: false,
      editSectionModal: false,
      backupSection: {},
      editableElement: {},
      elementIndex: "",
      dataHome: null,
      categories: [],
      errorMessage: "",
      alertRemoveCategory: false,
      alertCloneCategory: false,
      msgLoading: "Carregando...",
      siteHeaderScript: "",
      siteFooterScript: "",
      updatingScripts: false,
      errorScript: "",
      isHomePage: false,
      loadingClone: false,
      mainImagePost: [],
      classOptions: [
        {
          text: "Centralizado",
          value: "center-center",
        },
        {
          text: "Topo a direita",
          value: "top-right",
        },
        {
          text: "Topo ao centro",
          value: "top-center",
        },
        {
          text: "Topo a esquerda",
          value: "top-left",
        },
        {
          text: "Centralizado a direita",
          value: "center-right",
        },
        {
          text: "Centralizado a esquerda",
          value: "center-left",
        },
        {
          text: "Inferior a direita",
          value: "bottom-right",
        },
        {
          text: "Inferior ao centro",
          value: "bottom-center",
        },
        {
          text: "Inferior a esquerda",
          value: "bottom-left",
        },
      ],
    };
  },
  props: {
    saveData: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [sectionsMixins],
  components: {
    draggable,
    NewSection,
    CheckBox,
    ImageCarousel,
    MenuDraggable,
    Loading
  },
  created() {
    this.populateCategories();
    this.populateScripts();
    this.siteId = this.$session.get("siteId");
    this.siteUrl = JSON.parse(localStorage.siteData).url;
  },
  methods: {
    handleClickCategory(listPages, categoryId, externalLink, categoryRoute) {
      console.log(listPages, categoryId, externalLink, categoryRoute);

      if (externalLink == "external_url") {
        this.$session.set("pageId", categoryId);
        this.$router.push("/dashboard/link-management");
      } else if (externalLink == "store") {
        this.$session.set("pageId", categoryId);
        this.$router.push("/dashboard/store-management");
      } else if (listPages == 0) {
        // Redirect para Post Editor
        this.$session.set("postId", categoryId);
        this.$router.push({
          name: "PostEditor",
          params: { postId: categoryId },
        });
      } else {
        this.$emit("updateActiveCategory", categoryId, categoryRoute);
      }
    },
    async handleSave() {
      this.loadingScreen = true;
      const res = await this.handleUpdate();
      this.loadingScreen = false;
    },
    getLink(siteUrl, route) {
        const url = this.isUrl(route);

        if (url) return route;
        return 'http://' + siteUrl + route;
    },
    isUrl(t) {
        // valida se o texto é uma url -- é necessario pois os links podem ser de páginas externas ( url ) ou apenas
        // uri de uma rota
        const isUrlReg = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);

        return isUrlReg.test(t);
    },
    async deletePage(option) {
      this.loadingScreen = true;

      await this.removeCategory(this.editableElement, option);

      this.loadingScreen = false;
    },
    setMainImagePost() {
      if (this.activeMainImage !== this.editableElement.ogImage) {
        this.mainImagePost = [
          {
            mainImage: this.activeMainImage,
            category: [
              {
                id: this.editableElement.id,
              },
            ],
          },
        ];
      }
    },
    normalizeName(text) {
      text = text.replace("<p>", "");
      text = text.replace("</p>", "");
      return text;
    },
    clonePage(postId) {
      this.loadingClone = true;
      let siteId = this.$session.get("siteId");
      let totalData = "";
      let token = this.$session.get("jwt");
      this.loadingClone = true;
      axios({
        method: "post",
        url:
          process.env.ROOT_API +
          "/api/site/" +
          siteId +
          "/post/" +
          postId +
          "/duplicate",
        data: totalData,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.data.status == 1) {
            this.$router.push({
              name: "PostEditor",
              params: { postId: response.data.id },
            });
          } else {
            alert("Erro ao duplicar post");
            this.loadingClone = false;
          }
        })
        .catch(function (response) {
          alert("Erro ao duplicar post");
          console.log("Erro ao dublicar posts");
          this.loadingClone = false;
        });
    },
  },
  watch: {
    saveData() {
      if (this.saveData) {
        var totalData = { categories: this.categories };
        let token = this.$session.get("jwt");
        axios({
          method: "post",
          url: `${process.env.ROOT_API}/api/site/${this.siteId}/category/update}`,
          data: totalData,
          headers: {
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            this.$store.dispatch("VERIFY_SITE");
            this.$emit("updateMenuOption");
          })
          .catch(function (response) {
            console.log("Erro ao salvar");
          });
      }
    },
  },
  computed: {
    hasStore() {
      return this.categories.some((category) => category.type == "store");
    },

    filterHome() {
      if (this.categories.length > 0) {
        return this.categories.filter((category) => category.isHome == true);
      }
    },
    excludeHome() {
      if (this.categories.length > 0) {
        return this.categories.filter((category) => category.isHome == false);
      }
    },
    ...mapGetters("dashboardModule", ["getActivePosts"]),
  },
};
</script>
<style>
.no-border {
  border: none !important;
}
.advanced-config {
  color: #777777;
  cursor: pointer;
  font-size: 1.2rem;
  margin-right: 15px;
}
textarea {
  font-size: 12px;
  outline: none;
}
.section-name {
  cursor: pointer;
}
.btn-secundario {
  background-color: #777;
  color: #fff;
}
.add-section:hover {
  cursor: pointer;
}
.error-message {
  color: red;
  font-weight: 500;
}
.advanced-danger {
  color: #fc9bae;
}
.section-message {
  color: #777;
}
.item,
.item-no-draggable {
  border: 1px solid #e0e0e0;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 0;
  display: block;
  font-size: 16px;
}
.text {
  display: inline-block;
}
.moveIcon,
.removeIcon {
  padding: 0 10px;
  display: inline-block;
}
.removeIcon img:hover {
  cursor: pointer;
}
.moveIcon i {
  color: #777;
}
.moveIcon i:hover {
  color: var(--main-color);
}
.removeIcon img {
  height: 18px;
}
#SessoesComponent {
  padding-bottom: 45px;
}
.toggle-item img {
  height: 18px;
}
.toggle-item img:hover {
  cursor: pointer;
}
.border-bottom-gray {
  border-bottom: 1px solid #cecece;
}
</style>



// WEBPACK FOOTER //
// src/components/SessoesComponent.vue